var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "instagram-v2-page-selector" }, [
    _c("div", { staticClass: "page-card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "page-card-body" }, [
        _c(
          "div",
          { staticClass: "page-card-body-content" },
          _vm._l(_vm.getInstagramPages(), function (page) {
            return _c(
              "div",
              { key: page.id, staticClass: "page-card-body-content-item" },
              [
                _c(
                  "div",
                  { staticClass: "page-card-body-content-item-image" },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          page.instagram_business_account.profile_picture_url ||
                          "https://via.placeholder.com/80",
                        alt: "page image",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "page-card-body-content-item-info" }, [
                  _c(
                    "div",
                    { staticClass: "page-card-body-content-item-info-name" },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            page.instagram_business_account.name ||
                              page.instagram_business_account.username
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-card-body-content-item-info-username",
                    },
                    [
                      _vm._v(
                        "\n                            @" +
                          _vm._s(page.instagram_business_account.username) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-card-body-content-item-action" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: {
                          primary: "",
                          disabled: _vm.isConnectedBefore(page),
                        },
                        on: {
                          click: function () {
                            return _vm.changeValue(page)
                          },
                        },
                      },
                      [
                        _vm.isConnectedBefore(page)
                          ? _c("span", [_vm._v("Connected")])
                          : _c("span", [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.select"))),
                            ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-card-header" }, [
      _c("div", { staticClass: "page-card-header-title" }, [
        _vm._v("Instagram Hesabınızı Seçin"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }